module.exports = __webpack_public_path__ + "img/giuliana-margaria.9cb9297f.jpg";